import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SalesSummary } from '@sales/models/sales-summary';
import { AppData } from '@shared/models/appdata.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SalesSummaryService {
  private http = inject(HttpClient);
  private appData = inject(AppData);

  apiUrl = `${this.appData.apiUrl}/api/v1`;

  salesSummary(): Observable<SalesSummary> {
    const url = `${this.apiUrl}/sales`;
    return this.http.get<SalesSummary>(url);
  }
}
